<script>
import CreateModal from './createModal.vue';
import DeleteModal from 'dashboard/components/dahreply/DeleteModal.vue';
import LinkServiceModal from './LinkServiceModalV2.vue';

export default {
  name: 'PromotionsModals',
  components: {
    CreateModal,
    DeleteModal,
    LinkServiceModal,
  },
  props: {
    showCreate: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
    editObject: {
      type: Object,
      default: null,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
    deleteName: {
      type: String,
      default: null,
    },
    isDeleting: {
      type: Boolean,
      default: false,
    },
    showServices: {
      type: Boolean,
      default: false,
    },
    selectedId: {
      type: [String, Number],
      default: null,
    },
    accountId: {
      type: Number,
      required: true,
    },
  },
  emits: ['close:create', 'close:edit', 'close:delete', 'close:services', 'confirm-delete', 'refresh'],
  methods: {
    handleCloseCreate() {
      this.$emit('close:create');
    },
    handleCloseEdit() {
      this.$emit('close:edit');
    },
    handleCloseDelete() {
      this.$emit('close:delete');
    },
    handleConfirmDelete() {
      this.$emit('confirm-delete');
    },
    handleCloseServices() {
      this.$emit('close:services');
    },
    handleRefresh() {
      this.$emit('refresh');
    },
  },
};
</script>

<template>
  <div>
    <!-- Create Modal -->
    <CreateModal
      v-if="showCreate"
      :account-id="accountId"
      @close="handleCloseCreate"
      @refresh="handleRefresh"
    />

    <!-- Edit Modal -->
    <CreateModal
      v-if="showEdit"
      :is-edit="true"
      :edit="editObject"
      :account-id="accountId"
      @close="handleCloseEdit"
      @refresh="handleRefresh"
    />

    <!-- Delete Modal -->
    <DeleteModal
      v-if="showDelete"
      :delete-name="deleteName"
      :is-loading="isDeleting"
      @confirm="handleConfirmDelete"
      @close="handleCloseDelete"
    />

    <!-- Link Service Modal -->
    <LinkServiceModal
      v-if="showServices"
      :voucher-id="selectedId"
      :account-id="accountId"
      @close="handleCloseServices"
      @refresh="handleRefresh"
    />
  </div>
</template>
